<template>
  <div v-if="expeditionsStore.userData" class="h-16 max-w-md w-full">
    <!-- Basic Info Box -->
    <div class="w-full h-full">
      <div class="bg-white rounded-xl px-4 py-3 flex items-center justify-between h-full">
        <component
          :is="isBlurred ? 'div' : 'router-link'"
          class="flex items-center"
          :class="{ 'blur-md select-none': isBlurred }"
          :to="isBlurred ? undefined : `/profile/${expeditionsStore.userData?.username}`"
        >
          <div class="flex-shrink-0 h-10 w-10">
            <img
              v-if="expeditionsStore.userData?.avatar_image"
              class="h-10 w-10 rounded-full object-cover"
              :src="expeditionsStore.userData?.avatar_image"
              alt="User Avatar"
            />
            <div v-else class="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
              <UserRound class="h-6 w-6 text-gray-400" />
            </div>
          </div>
          <div class="ml-4 flex-grow w-full">
            <div class="text-md font-medium text-gray-900">
              {{ expeditionsStore.userData?.first_name }} {{ expeditionsStore.userData?.last_name }}
            </div>
            <div class="text-xs text-gray-500">{{ expeditionsStore.userData?.email }}</div>
          </div>
        </component>
        
        <Popover>
          <PopoverTrigger>
            <button
              class="rounded-full p-2 flex items-center hover:bg-gray-100 transition-all duration-200 float-right text-gray-500"
            >
              <EllipsisVertical class="h-4 w-4" />
            </button>
          </PopoverTrigger>
          <PopoverContent class="w-56 p-2">
            <div class="p-0">
              <router-link
                :to="`/profile/${expeditionsStore.userData?.username}`"
                class="rounded block px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                View Profile
              </router-link>

              <router-link
                :to="`/manage/review-history/user/${expeditionsStore.userData?.id}`"
                class="rounded block px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Task Review History
              </router-link>

              <router-link
                :to="`/manage/fellow/${expeditionsStore.userData?.id}`"
                class="rounded block px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Management Profile
              </router-link>

              <router-link
                v-if="isAdmin"
                :to="`/manage/${currentExpeditionId}/${expeditionsStore.userData?.id}/fellow-settings`"
                class="rounded block w-full text-left px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Fellow Settings
              </router-link>
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  </div>
  <div v-else class="flex flex-wrap gap-2 min-h-full">
    <!-- Basic Info Box Placeholder -->
    <div
      class="bg-white shadow-sm rounded-xl p-4 flex items-center justify-center flex-1 w-[20rem] h-20"
    >
      <Loader2 class="h-6 w-6 text-gray-400 animate-spin" />
    </div>
  </div>

  <SwitchExpeditionModal
    v-if="isSwitchModalOpen"
    :is-open="isSwitchModalOpen"
    :source-expedition-id="currentExpeditionId"
    :user-id="expeditionsStore.userData?.id"
    :user-name="`${expeditionsStore.userData?.first_name} ${expeditionsStore.userData?.last_name}`"
    @close="isSwitchModalOpen = false"
  />
</template>

<script setup lang="ts">
import { UserRound, Loader2, EllipsisVertical } from 'lucide-vue-next'
import { computed, ref } from 'vue'
import { useExpeditionsStore } from '@/stores/expeditions'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import SwitchExpeditionModal from '@/components/manage/SwitchExpeditionModal.vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { usePrivacyMode } from '@/composables/usePrivacyMode'

const { isAdmin } = useAuth()
const { isBlurred } = usePrivacyMode()

const props = defineProps<{
  expeditionId?: string
}>()

const route = useRoute()
const expeditionsStore = useExpeditionsStore()
const isSwitchModalOpen = ref(false)
const currentExpeditionId = computed(() => {
  if (props.expeditionId) return props.expeditionId
  if (route.params.id) return route.params.id as string
  return route.params.expeditionId as string
})

</script>


